'use strict';

    angular
        .module('completeAir')
        .factory('airportService', airportService);

    airportService.$inject = ['$http', 'CONFIG', 'messageService']

    function airportService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/airports';

        var service = {
            getAirports: getAirports,
            getAirportsActiveDisable: getAirportsActiveDisable,
            getAirport: getAirport,
            getAirportsByCountry: getAirportsByCountry,
            getAirportsByRegionAndCity: getAirportsByRegionAndCity,
            saveAirport: saveAirport,
            updateAirport: updateAirport,
            deleteAirport: deleteAirport,
            searchByIataAndName: searchByIataAndName,
            updateAirportActive: updateAirportActive,
            updateAirportDisable: updateAirportDisable,
            getPageAirportsActiveDisable: getPageAirportsActiveDisable,
            getPageAirports: getPageAirports,
            thereAirportName: thereAirportName,
            thereAirportIataCode: thereAirportIataCode
        }

        return service;


        function getAirports(){
            return $http.get(urlBase + '?detailed=true')
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.airports : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAirportsActiveDisable(active){
            return $http.get(urlBase + '/activeDisable?active=' + active + '&detailed=true')
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.airports : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getAirport(airportId){
            return $http.get(urlBase + "/" + airportId + "?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('airports')
                });
        }

        function getAirportsByCountry(countryId){
            return $http.get(urlBase + "/byCountry/" + countryId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('airports')
                });
        }

        function getAirportsByRegionAndCity(regionId, cityId){
            return $http.get(urlBase + "/byRegionAndCity/"+regionId+"/city/"+cityId )
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.airports : [];
                })
                .catch(function(){
                    messageService.findAError('branchOffices')
                });
        }

        function saveAirport(airport){
            return $http.post(urlBase, airport)
                .then(function(response){
                    messageService.register('airports')
                    return response;
                })
                .catch(function(){
                    messageService.registerError('airports')
                });
        }

        function updateAirport(airportId, airport){
            return $http.put(urlBase + "/" + airportId, airport)
                .then(function(response){
                    messageService.registerUpdate('airports')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdate('airports')
                });
        }

        function deleteAirport(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(response){
                    messageService.registerDelete('airports');
                    return response;
                })
                .catch(function(error){
                    if(error.data[0] == undefined) {
                        if( error.data.message && (error.data.message.indexOf('Can not be deleted because you already have an association with another entity') >=0) ) {
                            messageService.associationWithAnotherEntityError('airports');
                        } else {
                            messageService.registerDeleteError('airports');
                        }
                    } else {
                        if(error.data[0].message.indexOf('airportActive')> -1){
                            messageService.registerDeleteGeneralError('airports','air.airport.airportActive');
                        } else{
                            messageService.registerDeleteError('airports');
                        }
                    }
                });
        }

        function searchByIataAndName(search){
            return $http.get(urlBase + "/search?search=" + search, {
                'headers': {'Loading-Overlay': false}})
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.airports : [];
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function updateAirportActive(airportId, boardingGates, airport){
            var params = (airport == null) ? "/active" : "/activeUpdate";
            return $http.put(urlBase + "/" + airportId + params, boardingGates)
                .then(function(response){
                    messageService.register('addAirports')
                    return response;
                })
                .catch(function(){
                    messageService.registerError('addAirports')
                });
        }

        function updateAirportDisable(airportId){
            return $http.put(urlBase + "/" + airportId + "/disable")
                .then(function(response){
                    messageService.registerDelete('addAirports');
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('airports','air.airport.associatedSegments');
                    } else{
                        messageService.registerDeleteError('addAirports');
                    }
                });
        }

        function getPageAirportsActiveDisable(page, size, active, detailed){
            return $http.get(urlBase + '/activeDisablePage?page=' + page + '&size=' + size + '&active=' + active + '&detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getPageAirports(page, size){
            return $http.get(urlBase + "/page?page=" + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function thereAirportName(name){

            return $http.get(urlBase + "/thereNameAirport/" + name, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function thereAirportIataCode(IataCode){

            return $http.get(urlBase + "/thereIataCode/" + IataCode, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }
    }
